import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X, Sparkles } from 'lucide-react';

const PublicNavbar: React.FC = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigationItems = [
    { name: 'Servicios', href: '/servicios' },
    { name: 'Nosotros', href: '/nosotros' },
    { name: 'Contacto', href: '/contacto' }
  ];

  const toggleMenu = (): void => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-[9999] bg-blue-900/95 backdrop-blur-md border-b border-blue-400/20 shadow-lg">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 sm:space-x-3 flex-shrink-0">
            <div className="bg-blue-700/40 backdrop-blur-sm rounded-full p-1.5 sm:p-2">
              <Sparkles className="w-6 h-6 sm:w-8 sm:h-8 text-white" />
            </div>
            <div className="text-white">
              <span className="text-base sm:text-2xl font-bold">SCOUT</span>
              <span className="text-base sm:text-2xl font-bold text-blue-300">MIND</span>
              <span className="text-xs sm:text-lg font-bold text-blue-200 ml-0.5 sm:ml-1">AI</span>
            </div>
          </Link>

          {/* Desktop Navigation - Chip Style */}
          <div className="hidden md:flex items-center space-x-3">
            {navigationItems.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="px-5 py-2 text-white hover:text-blue-900 hover:bg-white/90 transition-all duration-200 font-medium rounded-full backdrop-blur-sm bg-white/10"
              >
                {item.name}
              </Link>
            ))}
            <button
              onClick={() => navigate('/login')}
              className="bg-blue-600 hover:bg-blue-500 text-white px-6 py-2 rounded-full font-medium transition-all duration-200 transform hover:scale-105 shadow-lg"
            >
              Entrar
            </button>
          </div>

          {/* Mobile menu button - Chip Style */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="bg-white/10 hover:bg-white/20 text-white p-2.5 rounded-full transition-all duration-200 backdrop-blur-sm"
              aria-label={isMenuOpen ? 'Cerrar menú' : 'Abrir menú'}
            >
              {isMenuOpen ? (
                <X className="w-5 h-5" />
              ) : (
                <Menu className="w-5 h-5" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation - Chip Style */}
        {isMenuOpen && (
          <div className="md:hidden pb-4">
            <div className="px-3 pt-3 pb-4 space-y-2 bg-blue-800/50 backdrop-blur-lg rounded-2xl mt-3 mb-2 border border-blue-400/30 shadow-xl">
              {navigationItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="block px-5 py-2.5 text-white hover:text-blue-900 hover:bg-white/90 rounded-full transition-all duration-200 text-sm font-medium text-center bg-white/10 backdrop-blur-sm"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <button
                onClick={() => {
                  navigate('/login');
                  setIsMenuOpen(false);
                }}
                className="w-full px-5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white rounded-full font-medium transition-all duration-200 shadow-lg text-sm"
              >
                Entrar
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default PublicNavbar;
